import { ProductVariant } from '../../common/gql/graphql';

export function qualifiesForLetterboxService(
    variants: Array<Pick<ProductVariant, 'shippingInformation' | 'id'>> = [],
    selectedVariantId: string | null,
) {
    const allVariantsAreLargeShipping =
        variants.length > 0 &&
        variants.every((variant) => !!variant.shippingInformation.find((i) => i.code === 'large-letter'));
    const selectedVariant = !!selectedVariantId && variants.find((v) => v.id === selectedVariantId);
    return selectedVariant
        ? !!selectedVariant.shippingInformation.find((i) => i.code === 'large-letter')
        : allVariantsAreLargeShipping;
}
